import { useMemo } from 'react';
import { GuidT, SelectIF } from '@/types/common';
import {
    createWardrobeCategories,
    getWardrobeParentCategoryGuids,
    getWardrobeParentCategories,
} from '@/helpers/wardrobeCategories';
import { WardrobeCategoryIF } from '@/constants/wardrobeCategoryTabs';

interface UseWardrobeCategoriesIF {
    wardrobeCategories: WardrobeCategoryIF[];
    parentCategories: SelectIF<GuidT>[];
    parentCategoryGuids: Set<GuidT>;
}

export const useWardrobeCategories = (
    categories: SelectIF<GuidT>[] | null | undefined,
): UseWardrobeCategoriesIF => {
    const wardrobeCategories = useMemo(
        () => createWardrobeCategories(categories),
        [categories],
    );

    const parentCategories = useMemo(
        () => getWardrobeParentCategories(categories),
        [categories],
    );

    const parentCategoryGuids = useMemo(
        () => getWardrobeParentCategoryGuids(categories),
        [categories],
    );

    return {
        wardrobeCategories,
        parentCategories,
        parentCategoryGuids,
    };
};
